<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              v-if="canUserCreate"
              type="primary"
              class="min-button"
              @click="saveOperator()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="operator.businessDetails.image"
                          v-bind:style="{
                            backgroundImage:
                              'url(' + operator.businessDetails.image + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card ">
                <div class="row">
                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <span class="">
                      Supplier Status
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span class="mb-2 d-block">
                          <strong>- Active:</strong> The supplier can log in and
                          manage their operations (Reservations, Rates,
                          Customers, etc.).
                        </span>

                        <span class="mb-2 d-block">
                          <strong>- Inactive:</strong> The supplier cannot log
                          in.</span
                        >
                        <span>
                          <strong>Note:</strong> You cannot deactivate a
                          supplier if there are pending reservations from
                          RhomTrip associated with them.
                        </span>

                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </span>
                  </div>
                  <div
                    class="col-xl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center"
                  >
                    <base-switch
                      v-model="operatorStatus"
                      @input="changeOperatorStatus"
                    ></base-switch>
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <span class="">
                      Restrict to Experiences Only
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span class="mb-2 d-block">
                          <strong>- Active:</strong> Enable this supplier to
                          restrict use to the experiences module only. </span
                        ><span class="mb-2 d-block">
                          <strong>- Inactive:</strong> Turn off for
                          transfer-related searches.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </span>
                  </div>
                  <div
                    class="col-xl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center"
                  >
                    <base-switch
                      onText="Yes"
                      offText="No"
                      v-model="serviceType"
                      @input="servicesProvided"
                    ></base-switch>
                  </div>

                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <span class="">
                      Affiliate Network
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span class="mb-2 d-block">
                          This supplier can be selected from RhomTrip's pool of
                          suppliers for quoting. </span
                        ><span class="mb-2 d-block">
                          <strong>Note:</strong> This option is independent of
                          the supplier's active status. Even if a supplier is
                          active, their services will not be available for
                          quoting unless this option is enabled. The rates and
                          areas offered to RhomTrip are distinct from those set
                          by the supplier independently.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </span>
                  </div>
                  <div
                    class="col-xl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center"
                  >
                    <base-switch
                      onText="Yes"
                      offText="No"
                      v-model="operatorAffiliate"
                      @input="changeAffiliateNetwork"
                    ></base-switch>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="mb-4 ">
                      <el-input
                        v-model="$v.operator.notes.$model"
                        placeholder="Notes"
                        id="operator_notes"
                        name="operator_notes"
                        maxlength="500"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 20 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <div class="card">
            <h2 class="subtitle">
              Business Details
            </h2>
            <div class="row mt-2">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.operator.businessDetails.name.$model"
                  id="operator_name"
                  name="operator_name"
                  label="DBA Name "
                  placeholder="DBA Name"
                  markrequired
                  :error="
                    !$v.operator.businessDetails.name.minLength ||
                    $v.operator.businessDetails.name.$error
                      ? `Enter from ${$v.operator.businessDetails.name.$params.minLength.min} to ${$v.operator.businessDetails.name.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-6 col-lg-8 col-md-6 col-sm-8 col-12">
                <base-input
                  v-model="$v.operator.businessDetails.legalName.$model"
                  id="legal_name"
                  name="legal_name"
                  label="Legal Name "
                  placeholder="Legal Name"
                  markrequired
                  :error="
                    !$v.operator.businessDetails.legalName.minLength ||
                    $v.operator.businessDetails.legalName.$error
                      ? `Enter from ${$v.operator.businessDetails.legalName.$params.minLength.min} to ${$v.operator.businessDetails.legalName.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.operator.businessDetails.vatNumber.$model"
                  label="VAT Number"
                  placeholder="VAT Number"
                  id="bussiness_VatNumber"
                  name="bussiness_VatNumber"
                  maxlength="45"
                  :error="
                    !$v.operator.businessDetails.vatNumber.minLength
                      ? `Enter from ${$v.operator.businessDetails.vatNumber.$params.minLength.min} to ${$v.operator.businessDetails.vatNumber.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="
                    $v.operator.businessDetails.licenseNumber.$model
                  "
                  label="License Number"
                  placeholder="license Number"
                  id="bussiness_licenseNumber"
                  name="bussiness_licenseNumber"
                  tabindex="2"
                  maxlength="45"
                  :error="
                    !$v.operator.businessDetails.licenseNumber.minLength
                      ? `Enter from ${$v.operator.businessDetails.licenseNumber.$params.minLength.min} to ${$v.operator.businessDetails.licenseNumber.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">
              Main Contact
            </h2>
            <div class="row mt-2">
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.operator.contactPerson.firstName.$model"
                  id="operator_FirstName"
                  name="operator_FirstName"
                  label="First Name"
                  placeholder="First Name"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.operator.contactPerson.firstName.minLength ||
                    $v.operator.contactPerson.firstName.$error
                      ? `Enter from ${$v.operator.contactPerson.firstName.$params.minLength.min} to ${$v.operator.contactPerson.firstName.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.operator.contactPerson.lastName.$model"
                  id="operator_LastName"
                  name="operator_LastName"
                  label="Last Name"
                  placeholder="Last Name"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.operator.contactPerson.lastName.minLength ||
                    $v.operator.contactPerson.lastName.$error
                      ? `Enter from ${$v.operator.contactPerson.lastName.$params.minLength.min} to ${$v.operator.contactPerson.lastName.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>
              <div
                class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 form-group"
                v-bind:class="{
                  'is-invalid': $v.operator.contactPerson.gender.$error
                }"
              >
                <label for="title" class="title-label">Gender</label>
                <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                  <b-form-radio-group
                    v-model="$v.operator.contactPerson.gender.$model"
                    :aria-describedby="ariaDescribedby"
                    id="radio-gender"
                    name="radio-gender"
                    buttons
                    button-variant="outline-neutral"
                    size="md"
                    tabindex="3"
                  >
                    <b-form-radio value="male" class="pc-4" tabindex="3"
                      >Mr.</b-form-radio
                    >
                    <b-form-radio value="female" class="pc-4"
                      >Mrs.</b-form-radio
                    >
                    <b-form-radio value="other" class="pc-4">Mx.</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

                <small
                  class="invalid-feedback mt-1"
                  v-if="$v.operator.contactPerson.gender.$error"
                  >Select</small
                >
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <base-input
                  v-model.trim="$v.operator.contactPerson.email.$model"
                  id="operator_email"
                  name="operator_email"
                  label="Supplier Email "
                  placeholder="example@email.com"
                  markrequired
                  :error="
                    !$v.operator.contactPerson.email.email ||
                    $v.operator.contactPerson.email.$error
                      ? `Enter a valid email`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
              >
                <label
                  class="title-label"
                  v-bind:class="{
                    'is-invalid': $v.phoneNumbers.contactNumber.$error
                  }"
                  ><span class="markrequired">*</span>Contact Number</label
                >
                <vue-tel-input
                  v-model="contactNumber"
                  key="operatorPhone"
                  inputId="operatorPhone"
                  name="OperatorPhone"
                  required
                  mode="international"
                  inputClasses=""
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  :wrapperClasses="[
                    $v.phoneNumbers.contactNumber.$error ? 'is-invalid' : '',
                    'mb-0'
                  ]"
                  @input="validateContactNumber"
                ></vue-tel-input>
                <small
                  class="invalid-feedback"
                  v-if="$v.phoneNumbers.contactNumber.$error"
                  >Enter a valid Phone Number.</small
                >
              </div>

              <div
                class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
              >
                <label class="title-label">Optional Phone</label>
                <vue-tel-input
                  v-model="optionalContactNumber"
                  key="optionalPhone"
                  inputId="optionalPhone"
                  name="optionalPhone"
                  required
                  mode="international"
                  inputClasses="input"
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  :wrapperClasses="[
                    $v.phoneNumbers.optionalContactNumber.$error
                      ? 'is-invalid'
                      : '',
                    'mb-0'
                  ]"
                  @validate="validateOptionalContactNumber"
                ></vue-tel-input>
                <small
                  class="invalid-feedback"
                  v-if="$v.phoneNumbers.optionalContactNumber.$error"
                  >Enter a valid phone</small
                >
              </div>
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <base-input
                  v-model="$v.operator.businessDetails.website.$model"
                  id="Web"
                  name="Web"
                  label="Website "
                  placeholder="www.rhomtrip.com"
                  :error="
                    $v.operator.businessDetails.website.$error
                      ? `Invalid Website: must use either http or https`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 switch-md mb-2"
              >
                <label for="driver_notifications" class="title-label ml-0">
                  Driver notifications
                  <el-popover
                    placement="top"
                    trigger="hover"
                    width="300"
                    class="curp"
                  >
                    <span>
                      Activate this if the supplier should receive notifications
                      requesting driver information
                    </span>
                    <div class="badge badge-primary" slot="reference">
                      ?
                    </div>
                  </el-popover>
                </label>
                <base-switch
                  v-model="operator.notifications.requestDriver"
                  class="mt-2"
                ></base-switch>
              </div>
            </div>
          </div>

          <div class="card  ">
            <h2 class="subtitle">Account Info</h2>

            <div class="row mt-2">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                    <base-input
                      label="Account Email"
                      placeholder="Email Address"
                      id="operator_email"
                      name="operator_email"
                      maxlength="100"
                      format="lowercase"
                      autocomplete="off"
                      markrequired
                      v-model.trim="$v.operator.authentication.email.$model"
                      :error="
                        getEmailValidationMessage(
                          $v.operator.authentication.email
                        )
                      "
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"></div>

                  <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12"></div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.operator.authentication.password.$model"
                      label="Password"
                      placeholder="Password"
                      name="password"
                      id="password"
                      :type="inputType"
                      autocomplete="new-password"
                      maxlength="20"
                      tabindex="15"
                      class="input-append mb-0"
                      markrequired
                      :tooltip="true"
                      titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                      contentTooltip='<ul class="ul-pop">
                                  <li>Enter from 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                      v-bind:class="{
                        'is-invalid': $v.operator.authentication.password.$error
                      }"
                      ><template slot="append">
                        <span @click="seePassword()" class="icon-button"
                          ><i
                            v-bind:class="{
                              'flaticon-view-1': inputType == 'password',
                              'flaticon-hidden': inputType == 'text'
                            }"
                          ></i
                        ></span>
                      </template>
                    </base-input>
                    <small
                      class="invalid-feedback mt--1"
                      v-if="$v.operator.authentication.password.$error"
                      >{{
                        validatePassword($v.operator.authentication.password)
                      }}</small
                    >
                    <small
                      class="valid-feedback mt-0"
                      v-if="
                        $v.operator.authentication.password.strongPassword &&
                          $v.operator.authentication.password.$model
                      "
                      >Strong Password</small
                    >
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
                  >
                    <base-input
                      v-model.trim="$v.repeatPassword.$model"
                      label="Confirm Password"
                      placeholder="Confirm Password "
                      type="password"
                      id="confirm_password"
                      name="confirm_password"
                      maxlength="20"
                      tabindex="16"
                      :error="
                        !$v.repeatPassword.sameAsPassword ||
                        $v.repeatPassword.$error
                          ? `Passwords must be identical`
                          : ''
                      "
                    />
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12  form-group alinmov1"
                  >
                    <base-button
                      type="outline-secondary"
                      class="min-button"
                      @click="autogeneratePassword()"
                    >
                      <i class="flaticon-bold-lock"></i>Generate Password
                    </base-button>

                    <base-button
                      type="outline-secondary"
                      class="min-button"
                      v-clipboard:copy="
                        $v.operator.authentication.password.$model
                      "
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onErrorCopy"
                      v-if="$v.operator.authentication.password.$model"
                    >
                      <i class="flaticon-copy"></i>Copy Password
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card ">
            <h2 class="subtitle">Address</h2>

            <div class="row mt-2">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model="$v.operator.address.street.$model"
                  label="Street address, apartment, suite, etc."
                  placeholder="Street address, apartment, suite, etc"
                  id="operator_street"
                  name="operator_street"
                  maxlength="200"
                  tabindex="9"
                  format="capitalize"
                  :error="
                    !$v.operator.address.street.minLength ||
                    $v.operator.address.street.$error
                      ? `Enter from ${$v.operator.address.street.$params.minLength.min} to ${$v.operator.address.street.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.operator.address.city.$model"
                  label="City"
                  placeholder="City"
                  id="operator_city"
                  name="operator_city"
                  maxlength="45"
                  tabindex="10"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.operator.address.city.minLength ||
                    $v.operator.address.city.$error
                      ? `Enter from ${$v.operator.address.city.$params.minLength.min} to ${$v.operator.address.city.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.operator.address.state.$model"
                  label="State/Province/Region"
                  placeholder="State/Province/Region"
                  id="operator_state"
                  name="operator_state"
                  maxlength="45"
                  tabindex="11"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.operator.address.state.minLength ||
                    $v.operator.address.state.$error
                      ? `Enter from ${$v.operator.address.state.$params.minLength.min} to ${$v.operator.address.state.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model.trim="$v.operator.address.zipCode.$model"
                  label="Zip/Postal Code"
                  placeholder="Zip/Postal Code"
                  id="operator_zipcode"
                  name="operator_zipcode"
                  maxlength="45"
                  tabindex="12"
                  :error="
                    !$v.operator.address.zipCode.minLength ||
                    $v.operator.address.zipCode.$error
                      ? `Enter from ${$v.operator.address.zipCode.$params.minLength.min} to ${$v.operator.address.zipCode.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                <WSelect
                  v-bind:class="{
                    'invalid-feedback': $v.operator.address.country.$error
                  }"
                  v-model="$v.operator.address.country.$model"
                  label="Country"
                  placeholder="Enter a Country"
                  id="operator_country"
                  name="operator_country"
                  class="mb-0"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="searchCountry"
                  :loading="loading"
                  clearable
                  markrequired
                >
                  <el-option
                    v-for="country in countriesOptions"
                    :value="country.name"
                    :label="country.name"
                    :key="country.name"
                  ></el-option>
                </WSelect>
                <small
                  class="invalid-feedback mt-0"
                  v-if="$v.operator.address.country.$error"
                  >Enter a Country</small
                >
              </div>
              <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                <base-input
                  v-model.trim="$v.operator.address.otherStreet.$model"
                  id="operator_OtherAddress"
                  name="operator_OtherAddress"
                  label="Other Address"
                  placeholder="Other Address"
                  :error="
                    !$v.operator.address.otherStreet.minLength ||
                    $v.operator.address.otherStreet.error
                      ? `Enter from ${$v.operator.address.otherStreet.$params.minLength.min} to ${$v.operator.address.otherStreet.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  url
} from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { OperatorsAPI, AuthAPI } from "../../../core/api";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import lodash from "lodash";
import generator from "generate-password";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { FileService } from "../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewOperator",
  data() {
    return {
      operator: {
        businessDetails: {
          name: "",
          legalName: "",
          vatNumber: "",
          licenseNumber: "",
          website: "",
          image: ""
        },
        contactPerson: {
          firstName: "",
          lastName: "",
          fullName: "",
          gender: "other",
          phoneNumbers: [],
          email: ""
        },
        address: {
          country: "",
          city: "",
          state: "",
          zipCode: "",
          street: "",
          otherStreet: ""
        },
        type: "supplier",
        authentication: {
          email: "",
          password: "",
          accountStatus: "ACTIVE",
          verified: true
        },
        preferredContactMethod: "phoneNumber",
        paymentMethods: [],
        affiliate: true,
        notes: "",
        currency: "USD",
        notifications: {
          requestDriver: true
        },
        settings: {
          maximumDistance: 150,
          measurementUnit: "km",
          taxes: {
            type: "vat",
            value: 0
          }
        },
        serviceType: "TRANSFERS" // o "PRODUCTS"
      },
      operatorCopy: {},
      saved: false,
      repeatPassword: "",
      loading: false,
      inputType: "password",
      picture: "",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      tabActive: "",
      countriesOptions: [],
      coins: [
        { code: "USD", symbol: "$", label: "US Dollar" },
        { code: "EUR", symbol: "€", label: "Euro" },
        { code: "GBP", symbol: "£", label: "British Pound" },
        { code: "CHF", symbol: "₣", label: "Swiss Franc" },
        { code: "DKK", symbol: "kr", label: "Denmark Krone" },
        { code: "SEK", symbol: "kr", label: "Swedish Krona" },
        { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
        { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
        { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
      ],
      contactNumber: "",
      optionalContactNumber: "",
      phoneNumbers: {
        contactNumber: "",
        optionalContactNumber: ""
      },
      operatorStatus: true,
      operatorAffiliate: true,
      serviceType: false
    };
  },
  created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Suppliers",
        to: "/suppliers"
      },

      {
        text: "New Supplier",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.operatorCopy = lodash.cloneDeep(this.operator);
    this.countriesOptions = this.countries;
  },
  methods: {
    validateContactNumber(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.phoneNumbers.contactNumber = result.number.e164;
      } else {
        this.phoneNumbers.contactNumber = null;
      }
    },
    validateOptionalContactNumber(payload) {
      let result = payload;
      if (result.isValid) {
        this.phoneNumbers.optionalContactNumber = result.number.e164;
      }
    },
    async saveOperator(route = null) {
      if (
        !this.$v.operator.$invalid &&
        !this.$v.phoneNumbers.$invalid &&
        !this.$v.repeatPassword.$invalid
      ) {
        let operator = lodash.cloneDeep(this.operator);
        operator.contactPerson.fullName = `${operator.contactPerson.firstName} ${operator.contactPerson.lastName}`;
        operator.contactPerson.phoneNumbers = this.populatePhoneNumbers(
          this.phoneNumbers.contactNumber,
          this.phoneNumbers.optionalContactNumber
        );

        await this.createOperator(operator, route);
      } else {
        this.$v.operator.$touch();
        this.$v.phoneNumbers.$touch();
        this.$v.repeatPassword.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createOperator(operator, route = null) {
      try {
        this.setLoad(true);
        let { data } = await OperatorsAPI.createOperator(
          operator,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Supplier has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/suppliers");
        } else {
          this.$notify({
            type: "danger",
            message: "Error!. Could not saved the Supplier"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Supplier, please try again"
        );
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    validatePassword(password) {
      if (password.$error) {
        if (!password.$minLength) {
          return `Password must have at least ${password.$params.minLength.min} letters.`;
        } else if (password.$required && password.$model.length < 1) {
          return `Password is required`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    autogeneratePassword() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.operator.authentication.password = password;
      this.repeatPassword = password;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The password has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The password could not be copied",
        icon: "flaticon-remove"
      });
    },
    seePassword() {
      this.inputType = this.inputType == "password" ? "text" : "password";
    },
    isInSupplierModule(modules = []) {
      if (!(modules.indexOf("suppliers") > -1)) {
        this.setSupplierSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.operator, this.operatorCopy);
      if (!isEqual && !this.saved && this.canUserCreate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Supplier has been modified,<br> do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveOperator(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    readFile: async function(event) {
      const [file] = event.target.files;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.operator.businessDetails.image = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.operator.businessDetails.image = "";
      this.picture = "";
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.countriesOptions = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.countriesOptions = [];
      }
    },
    populatePhoneNumbers(contactNumber, optionalContactNumber) {
      return [
        {
          number: contactNumber,
          type: "mobile",
          preferred: true
        },
        {
          number: optionalContactNumber,
          type: "mobile",
          preferred: false
        }
      ];
    },
    async verifyOperatorEmail(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    changeOperatorStatus(operatorStatus) {
      this.operator.authentication.accountStatus = operatorStatus
        ? "ACTIVE"
        : "INACTIVE";
    },
    changeAffiliateNetwork(value) {
      if (["Payment Info", "Destinations"].includes(this.tabActive)) {
        this.tabActive = "Overview";
      }
      this.operator.affiliate = value;
    },
    servicesProvided(value) {
      this.operator.serviceType = value ? "PRODUCTS" : "TRANSFERS";
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setSupplierSearchCriteria"
    ])
  },
  beforeRouteLeave(to, from, next) {
    this.isInSupplierModule(to.meta.modules);
    if (!this.sigout) {
      this.detectChanges(to, from, next);
    } else {
      next();
    }
  },
  validations: {
    operator: {
      businessDetails: {
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        legalName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        vatNumber: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        licenseNumber: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        website: {
          url
        }
      },
      address: {
        country: {
          ValName,
          required,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        city: {
          ValName,
          required,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        state: {
          ValName,
          required,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        zipCode: {
          minLength: minLength(4),
          maxLength: maxLength(10)
        },
        street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        otherStreet: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        }
      },
      contactPerson: {
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        gender: {
          required: false
        },
        email: {
          required,
          email
        }
      },
      authentication: {
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (this.validateEmail(value)) {
              return await this.verifyOperatorEmail(value);
            } else {
              return false;
            }
          }
        },
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            return (
              /[a-z]/.test(password) && // checks for a-z
              /[A-Z]/.test(password) && // checks for A-Z
              /[0-9]/.test(password) && // checks for 0-9
              /\W|_/.test(password) && // checks for special char
              password.length >= 8
            );
          }
        }
      },
      notes: {
        maxLength: maxLength(500)
      }
    },
    phoneNumbers: {
      contactNumber: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(25)
      },
      optionalContactNumber: {
        minLength: minLength(7),
        maxLength: maxLength(25)
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.operator.authentication.password;
      })
    }
  },
  computed: {
    ...mapGetters(["countries", "sesion", "userRole", "sigout"]),
    canUserCreate() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "CREATE");
    }
  },
  components: {
    VueTelInput,
    WSelect
  }
};
</script>
